import { Component, ViewChild } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { UserLogsService } from '../../services/UserLogs.service';
import { GenericTableComponent } from 'src/app/features/shared/features/generic-table/components/generic-table.component';
import { CatalogPaginationRequest } from 'src/app/features/shared/models/CatalogPagination/CatalogPaginationRequest';
import { FilterRequest } from 'src/app/features/shared/models/Filter/FilterRequest';
import { UserLogsCatalogKeys } from '../../models/UserLogsCatalogKeys';

@Component({
  selector: 'user-logsPage',
  templateUrl: './user-logsPage.component.html',
  styleUrls: ['./user-logsPage.component.css']
})
export class UserLogsPageComponent {

  
}
